import { db, serverTimestamp } from "../../firebaseClient";
import { createRef } from "./refService";

const LINK_KEY = "DEMO_LINKSET_01";
const DATA_SET = {
  contractNo: "CT-DEMO-000777",
  brandAssetNo: "BA-DEMO-000321",
  ipNo: "IP-DEMO-000888",
  civilCaseNo: "CASE-DEMO-2025-0001"
};

/**
 * Creates or updates a full set of linked demo records.
 * Uses fixed document IDs to ensure idempotency.
 */
export async function setupDemoLinkSet01(userEmail: string) {
  const batch = db.batch();

  // 1. Contract
  const ctRef = db.collection("legal_contracts").doc("DEMO_LINKSET_01_CT");
  batch.set(ctRef, {
    contractNo: DATA_SET.contractNo,
    title: "【示範】品牌授權暨維權委任合約 (2025)",
    counterparty: "跨國代理商 A 公司",
    department: "總經理室",
    status: "生效中",
    periodStart: "2025-01-01",
    periodEnd: "2030-12-31",
    linkKey: LINK_KEY,
    relatedNos: DATA_SET,
    isLegacy: false,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  }, { merge: true });

  // 2. Brand Asset
  const baRef = db.collection("brand_assets").doc("DEMO_LINKSET_01_BA");
  batch.set(baRef, {
    assetNo: DATA_SET.brandAssetNo,
    name: "SF-Premium",
    group: "代理品牌",
    type: "商標",
    region: "台灣/日本",
    status: "有效",
    linkKey: LINK_KEY,
    relatedNos: DATA_SET,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  }, { merge: true });

  // 3. IP Asset (Infringement Action)
  const ipRef = db.collection("ip_assets").doc("DEMO_LINKSET_01_IP");
  batch.set(ipRef, {
    ipNo: DATA_SET.ipNo,
    title: "SF-Premium 商標侵權移除行動 (2025)",
    type: "商標",
    jurisdiction: "台灣",
    status: "維權中",
    linkKey: LINK_KEY,
    relatedNos: DATA_SET,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  }, { merge: true });

  // 4. Civil Case (Legal Matter)
  const caseRef = db.collection("legal_matters").doc("DEMO_LINKSET_01_CASE");
  batch.set(caseRef, {
    matterNo: DATA_SET.civilCaseNo,
    title: "【示範】SF-Premium 品牌損害賠償訴訟 - A 公司案",
    type: "案件",
    status: "進行中",
    riskLevel: "HIGH",
    department: "法務部",
    counterparty: "仿冒品進口商 B 先生",
    linkKey: LINK_KEY,
    relatedNos: DATA_SET,
    summary: "此為 Pkg3 示範串聯資料。本案涉及 CT-DEMO-000777 合約授權地位，及 BA-DEMO-000321 品牌價值損失。",
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp()
  }, { merge: true });

  await batch.commit();

  // 5. Create Cross-Module Refs
  await createRef({
    refType: 'INTERNAL',
    title: "【示範串聯】DEMO_LINKSET_01 完整卷宗關聯",
    sourceUrl: "internal://demo-link-01",
    linkedEntityIds: [
        "DEMO_LINKSET_01_CT", 
        "DEMO_LINKSET_01_BA", 
        "DEMO_LINKSET_01_IP", 
        "DEMO_LINKSET_01_CASE"
    ],
    description: "此 Refs 同時指向合約、品牌、智財與案件。"
  });

  return DATA_SET;
}
